import reactCSS from 'reactcss';
import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px } from '@ux/theme-utils';
import { TypefaceStyle } from '@ux/typeface';
import { content, headingM, headingS } from '@ux/type-size';
import * as r from 'ramda';

export default ({
  isMinSm,
  isMinMd,
  theme: {
    spacing,
    palette,
    typography,
  },
}) => reactCSS({
  default: {
    root: {
      ...cssSides('padding', Side.A, gu2px(3, spacing)),
      backgroundColor: '#fff',
      color: palette.grey04,
      ...content(typography),
    },
    promo: {
      marginLeft: r.negate(gu2px(1, spacing)),
      color: palette.highlight,
      fontWeight: 'bold',
    },
    text: {
      marginTop: gu2px(2, spacing),
      marginBottom: 0,
    },
    link: {
      default: {
        color: palette.secondary,
      },
    },
    domains: {
      fontFamily: typography[TypefaceStyle.DISPLAY],
      overflow: 'hidden',
      listStyle: 'none',
      ...headingM(typography),
      ...cssSides('padding', Side.A, 0),
      ...cssSides('margin', Side.A, 0),
    },
    domain: {
      marginTop: gu2px(2, spacing),
    },
    cost: {
      marginTop: gu2px(3, spacing),
      marginBottom: gu2px(3, spacing),
      fontFamily: typography[TypefaceStyle.DISPLAY],
    },
    priceText: {
      paddingRight: gu2px(2, spacing),
      ...headingS(typography),
    },
    price: {
      color: palette.primary,
      fontWeight: 'bold',
    },
    oldPrice: {
      textDecoration: 'line-through',
      color: palette.grey08,
    },
  },

  isMinSm: {
    root: {
      display: 'flex',
      textAlign: 'left',
      alignItems: 'flex-end',
    },
    body: {
      maxWidth: '60%',
      paddingRight: gu2px(3, spacing),
      marginRight: 'auto',
    },
    action: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    cost: {
      marginTop: 0,
      marginBottom: gu2px(2, spacing),
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'baseline',
    },
    priceText: {
      paddingRight: 0,
      paddingLeft: gu2px(2, spacing),
    },
  },

  isMinMd: {
    root: {
      ...cssSides('padding', Side.A, gu2px(4, spacing)),
    },
  },
}, [
  { isMinSm },
  { isMinMd },
]);
